import React from 'react';

export interface CommerceFormFieldErrorsProps {
  issues: string[];
  styles: Record<string, string>;
}

const CommerceFormFieldErrors: React.FC<CommerceFormFieldErrorsProps> = ({ issues, styles }) => {
  if (issues.length === 0) return null;
  return (
    <div className={styles.errorBlock} role="alert">
      <p className={styles.errorLead}>Revisá lo siguiente antes de guardar:</p>
      <ul className={styles.errorList}>
        {issues.map((text, i) => (
          <li key={`${i}-${text}`}>{text}</li>
        ))}
      </ul>
    </div>
  );
};

export default CommerceFormFieldErrors;
